import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 3.57143L4.27273 7L10 1"
      stroke="#01C44F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const UnlinedTick = (props) => <Icon component={svg} {...props} />;

export default UnlinedTick;
